var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { ref: "modal", attrs: { heading: "Pass Applicant" } }, [
    _c("div", { staticClass: "mb-4" }, [
      _c("h5", [
        _vm._v(
          _vm._s(
            this.manual_pass
              ? "Are you sure? None of the iFacts checks will be sent. All results will be available in the next stage."
              : _vm.message
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
      _c("div", { staticClass: "cell auto" }, [
        _c("div", { staticClass: "input checkbox required cell terms" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.manual_pass,
                expression: "manual_pass"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "keep_me_login",
              value: "1",
              id: "l_login_keep"
            },
            domProps: {
              checked: Array.isArray(_vm.manual_pass)
                ? _vm._i(_vm.manual_pass, "1") > -1
                : _vm.manual_pass
            },
            on: {
              change: function($event) {
                var $$a = _vm.manual_pass,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = "1",
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.manual_pass = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.manual_pass = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.manual_pass = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "l_login_keep" } }, [
            _vm._v(
              "I confirm that I have manually sent the iFacts and understand that the system will not send them on my behalf"
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
      _c("div", { staticClass: "cell shrink" }, [
        _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
          _c("div", { staticClass: "cell shrink" }, [
            _c(
              "button",
              {
                staticClass: "button success",
                attrs: { disabled: _vm.isSubmitted, type: "button" },
                on: { click: _vm.pass }
              },
              [_vm._v("Pass")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell shrink" }, [
            _c(
              "button",
              {
                staticClass: "button warning",
                attrs: { type: "button" },
                on: { click: _vm.toggleModal }
              },
              [_vm._v("Close")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4ef7522", { render: render, staticRenderFns: staticRenderFns })
  }
}